import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Handles the lexxy:insert-link event fired when a user pastes a plain URL
// into the Lexxy editor. Fetches OG/title metadata from the server and
// replaces the bare URL with a human-readable linked title.
export default class extends Controller {
  static values = { url: String }

  unfurl(event) {
    this.#unfurlLink(event.detail.url, event.detail)
  }

  async #unfurlLink(url, callbacks) {
    const { response } = await post(this.urlValue, {
      body: JSON.stringify({ url }),
      headers: { "Content-Type": "application/json", "Accept": "application/json" }
    })

    if (!response.ok) return

    const { title, domain } = await response.json()
    const label = title || domain || url
    callbacks.replaceLinkWith(`<a href="${url}">${label}</a>`)
  }
}
